import styled from "styled-components";

// #####################################################

export const StyledSelectorLabelWrapper = styled.div`
	position: relative;
	pointer-events: none;
	font-size: 0.8rem;
	line-height: 12px;
	background: transparent;
	z-index: 2;
`;

// #####################################################
